import { render } from "./etUploadFile.vue?vue&type=template&id=00b66b86"
import script from "./etUploadFile.vue?vue&type=script&lang=js"
export * from "./etUploadFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__